import { render, staticRenderFns } from "./reference-rating.vue?vue&type=template&id=2be33ce8&"
import script from "./reference-rating.vue?vue&type=script&lang=js&"
export * from "./reference-rating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports